interface Config {
  apiUrl: string;
  stripePublicKey: string;
  isDevelopment: boolean;
}

const developmentConfig: Config = {
  apiUrl: 'http://localhost:3001',
  stripePublicKey: 'pk_test_51RR11NPHxAoX8RZ5ZomzoIY20Hocz6WLHLh9B9rmDD2YKU4NSaEwmTFw0yoGsoNGGi1aPfO1uveegmWb319qtDao003mxjo0AE',
  isDevelopment: true
};

const productionConfig: Config = {
  apiUrl: import.meta.env.VITE_API_URL ? 
    (import.meta.env.VITE_API_URL.startsWith('http') ? 
      import.meta.env.VITE_API_URL : 
      `https://${import.meta.env.VITE_API_URL}`) : '',
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',
  isDevelopment: false
};

export const config = import.meta.env.DEV ? developmentConfig : productionConfig;

// Validate production config
if (!import.meta.env.DEV) {
  if (!config.apiUrl) {
    console.error('VITE_API_URL is not set in production environment');
  }
  if (!config.stripePublicKey) {
    console.error('VITE_STRIPE_PUBLIC_KEY is not set in production environment');
  }
} 